import React, { useEffect, useContext, Fragment } from 'react';
import axios from 'axios';
import moment from 'moment';
import Link from 'next/link';
import { isEmpty } from 'lodash';
import {
  Box,
  Flex,
  Text,
  Icon,
  Image,
  Spinner,
  SimpleGrid,
  Alert,
  Button,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  useColorMode,
} from '@chakra-ui/react';
import { Container } from 'components/Container';
import { useSWRConfig } from 'swr';
import { deviceType } from 'react-device-detect';
import { priceUsd, priceStx, truncate } from 'utils/utility';
import notification from 'components/Notifications';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import DropdownMenu from 'components/CardCollection/DropdownMenu';
import { API } from 'config/api';
import { AuthContext } from 'contexts/auth/auth.context';
import AuctionEnded from './AuctionEnded';
import BuyNowButton from './BuyNowButton';
import SoldButton from './SoldButton';
import PlaceABidButton from './PlaceABidButton';
import SellButton from './SellButton';
import Cancel from './CancelButton';
import CurrentBid from './CurrentBid';
import BlockChainRecord from './BlockchainRecord';
import SendButton from './SendButton';
import { FiExternalLink } from 'react-icons/fi';
import AudioNft from './AudioNft';
import VideoNft from './VideoNft';
import UnlockableTag from 'components/UnlockableTag';
import { useRouter } from 'next/router';
import { useAuthDispatch } from 'contexts/0Auth';
import { bgColor } from 'config/data';
import { useCurrency } from 'contexts/currency/currency.provider';

const NftDetail = ({
  nftData,
  onOpenModal,
  onOpenModalEditions,
  favorites,
  access_token,
  token_id,
  user,
  collection,
  forSale,
  priceSTX,
  topBider,
  mynfts,
  txns,
}) => {
  const [device, setDevice] = React.useState('');
  const [cargando, setCargando] = React.useState(true);
  const [id, setId] = React.useState(-1);
  const [intent, setIntent] = React.useState({});
  const [error, setError] = React.useState('');
  const [days, setDays] = React.useState(0);
  const [hours, setHours] = React.useState(0);
  const [minutes, setMinutes] = React.useState(0);
  const [seconds, setSeconds] = React.useState(0);
  const [finish, setFinish] = React.useState(false);
  const [end, setEnd] = React.useState(false);
  const { colorMode } = useColorMode();
  const { nft, error: errStripe, token } = nftData;
  const { currency } = useCurrency();

  const {
    id: nft_id,
    contract_token_id,
    name,
    for_sale,
    price_micro_stx,
    non_fungible_token_collection,
    price_usd,
    auction,
    is_sold,
    edition,
    user: userNFt,
    file,
    mint_transaction,
  } = nft;

  const user_id = userNFt?.id;
  const non_fungible_token_collection_id = non_fungible_token_collection?.id;

  const { authDispatch } = useContext(AuthContext);
  const { mutate } = useSWRConfig();

  const { goToOauth } = useAuthDispatch();

  const router = useRouter();
  const pathname = router.asPath;

  const onGoToAuth = async () => {
    await axios.post('/api/current', { pathname });
    goToOauth();
  };

  useEffect(() => {
    if (auction) {
      setEnd(moment().isAfter(auction?.end_at));
      const end_at = moment(auction?.end_at).toString();
      const target = new Date(end_at);
      // const target = new Date('12/10/2021 23:59:59');
      const interval = setInterval(() => {
        const now = new Date();
        const difference = target.getTime() - now.getTime();
        const d = Math.floor(difference / (1000 * 60 * 60 * 24));
        setDays(d);
        const h = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        setHours(h);
        const m = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        setMinutes(m);
        const s = Math.floor((difference % (1000 * 60)) / 1000);
        setSeconds(s);
        if (d <= 0 && h <= 0 && m <= 0 && s <= 0) {
          setFinish(true);
          setDays(0);
          setHours('00');
          setMinutes('00');
          setSeconds('00');
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [auction]);

  useEffect(() => {
    setDevice(deviceType);
    if (for_sale !== null) {
      const config = { headers: { Authorization: `Bearer ${access_token}` } };
      API.post(`/nft/${nft_id}/purchase/intent/stx`, {}, config)
        .then((res) => setIntent(res.data))
        .catch((e) => setError(e.response.data.message));
    }
  }, [access_token, for_sale, nft_id, setDevice]);

  const onFavorite = () => {
    if (user?.isLoggedIn) {
      const config = { headers: { Authorization: `Bearer ${access_token}` } };
      API.post(`${process.env.NEXT_PUBLIC_API_URL}/me/favorites`, { id: nft_id }, config)
        .then((res) => {
          notification('success', `❤️ ${res.data.message}`);
          mutate([`${process.env.NEXT_PUBLIC_API_URL}/me/favorites`, access_token]);
        })
        .catch((err) => notification('error', err.response.data.message));
    } else {
      // authDispatch({ type: 'SHOW_MODAL' });
      onGoToAuth();
    }
  };

  const onDeleteFavorite = () => {
    API.delete(`/me/favorites`, { headers: { Authorization: access_token }, data: { id: nft_id } })
      .then((res) => {
        notification('success', `💔 ${res.data.message}`);
        mutate([`${process.env.NEXT_PUBLIC_API_URL}/me/favorites`, access_token]);
      })
      .catch((err) => notification('error', err.response.data.message));
  };

  const onReport = async (data) => {
    data.email = user?.email || 'support@heylayer.com';
    if (typeof window !== 'undefined') {
      setCargando(true);
      setId(data.id);
      const hostname = window.location.hostname;
      const url = `${hostname}/nft/${data.id}`;
      axios
        .post('/api/report', { url, ...data })
        .then((res) => {
          notification('success', `📝 ${res.data.message}`);
          setCargando(false);
        })
        .catch(() => setCargando(false));
    }
  };

  const onHide = async (values) => {
    console.log('values', values);
  };

  const priceUSD = process.env.NEXT_PUBLIC_TEST_STRIPE || price_usd;
  const exist = favorites.find((el) => el.contract_token_id === Number(token_id));
  // const collections = isEmpty(collection) ? [] : collection?.non_fungible_tokens;
  // const total = isEmpty(collection) ? 0 : collections.length;
  // const inCollection = isEmpty(collection) ? 0 : collections.findIndex((el) => el.id === nft_id);
  const firstWord = name?.split(' ')[0];

  return (
    <Box as="section" id="nft_detail" py={{ base: '5px', md: '30px' }} px={['15px', '10px', 0]} mb="40px">
      <Container>
        <Flex
          w={{ base: '100%', md: auction || days > 0 ? '900px' : file?.video_stream_urls ? '970px' : '840px' }}
          id="nft"
          m="0 auto"
          flexDirection={{ base: 'column', md: 'row' }}
        >
          <Flex
            w={{ base: '100%', md: file?.video_stream_urls ? '480px' : '400px' }}
            id="image"
            mr="40px"
            pos="relative"
          >
            {nft?.has_unlockables && file?.file_type !== 3 && <UnlockableTag />}
            {file?.video_stream_urls ? (
              <VideoNft file={file?.video_stream_urls?.hls} />
            ) : file?.file_type === 3 && file?.file_http_url ? (
              <AudioNft has_unlockables={nft?.has_unlockables} file={file?.file_http_url} />
            ) : (
              <Image
                src={file?.thumbnail_http_url || '/images/no_image.jpg'}
                alt={name}
                borderRadius={8}
                objectFit="fill"
                w="100%"
                h="auto"
                alignSelf="center"
              />
            )}
          </Flex>
          <Flex id="content" flexDirection="column" flex="1" justifyContent="center">
            <Flex id="title_section" justifyContent="space-between" alignItems="center">
              <Text
                fontSize={{ base: '24px', md: '36px' }}
                letterSpacing="-1.69px"
                fontWeight="bold"
                mt="10px"
                mr="10px"
                wordBreak={firstWord?.length > 15 ? 'break-all' : 'normal'}
              >
                {name}
              </Text>
              <Flex id="icons" alignItems="center">
                <Icon
                  fontSize="26px"
                  cursor="pointer"
                  mr="10px"
                  color={exist ? 'red.500' : ''}
                  as={exist ? AiFillHeart : AiOutlineHeart}
                  onClick={() => (exist ? onDeleteFavorite(contract_token_id) : onFavorite(contract_token_id))}
                />
                {cargando && id === contract_token_id ? (
                  <Spinner />
                ) : (
                  <DropdownMenu
                    user={user}
                    nftData={nft}
                    mynfts={mynfts}
                    onReport={onReport}
                    onHide={onHide}
                    isDetail={true}
                  />
                )}
              </Flex>
            </Flex>
            {!mint_transaction?.transaction_id && (
              <Popover placement="top-start" trigger="hover">
                <PopoverTrigger>
                  <Button
                    bg={colorMode === 'dark' ? '#1C1C1C' : '#f7f7f7'}
                    w="120px"
                    fontWeight="500"
                    fontSize="14px"
                    color="#67676c"
                    size="sm"
                    py="8px"
                    my="10px"
                  >
                    <Image src="/images/bxs_leaf.svg" alt="" w="20px" mr="7px" /> Lazy mint
                  </Button>
                </PopoverTrigger>
                <PopoverContent borderColor={colorMode === 'dark' ? '#333' : null}>
                  <PopoverArrow />

                  <PopoverBody
                    fontSize="12px"
                    color={colorMode === 'dark' ? 'gray.300' : 'gray.600'}
                    bg={bgColor[colorMode]}
                  >
                    Lazy Minting is the process of minting an NFT at the time of sale and not before. This NFT will be
                    minted when it is purchased. Until then it&apos;s stored on IPFS patiently waiting to be minted.
                  </PopoverBody>
                </PopoverContent>
              </Popover>
            )}

            {mint_transaction?.transaction_id && <BlockChainRecord mint_tx_id={mint_transaction?.transaction_id} />}

            {auction ? (
              end ? (
                <AuctionEnded topBider={topBider} auction={auction} price_usd={price_usd} finish={finish} />
              ) : (
                <>
                  <CurrentBid
                    auction={auction}
                    finish={finish}
                    price_micro_stx={price_micro_stx}
                    price_usd={price_usd}
                    days={days}
                    hours={hours}
                    minutes={minutes}
                    seconds={seconds}
                  />
                  {!finish && user_id !== user.id && <PlaceABidButton onOpenModal={onOpenModal} />}
                </>
              )
            ) : (
              <Flex id="price" mt="10px" mb="40px" flexDirection="column" fontSize="14px" fontWeight="500">
                {priceUSD && !is_sold && (
                  <>
                    <Text>Price</Text>
                    <Text fontWeight="bold" fontSize="36px" py="5px">{currency === 'usd' ? priceUSD && priceUsd(priceUSD) : for_sale === null ? priceStx(priceSTX) : priceStx(price_micro_stx)}</Text>
                  </>
                )}
                {/* !is_sold */}
                {(for_sale || forSale) && (
                  <Text >
                    {currency === "usd" ? for_sale === null ? priceStx(priceSTX) : priceStx(price_micro_stx) : priceUSD && priceUsd(priceUSD)}
                  </Text>
                )}
              </Flex>
            )}
            {/* Si esta a la venta via contrato mostrar boton para comprar */}
            {/* {forSale && !is_sold && <BuyNowButton onOpenModal={onOpenModal} />} */}
            {(for_sale || forSale) && user_id !== user.id && <BuyNowButton onOpenModal={onOpenModal} />}
            {is_sold && !forSale && !for_sale && user_id !== user.id && <SoldButton />}

            {/* {is_sold ? (
              <SoldButton />
            ) : (
              (!error || !errStripe) &&
              (for_sale ? (
                <BuyNowButton onOpenModal={onOpenModal} />
              ) : (
                forSale && <BuyNowButton onOpenModal={onOpenModal} />
              ))
            )} */}

            {!isEmpty(txns) && user_id === user.id && (
              <Flex mb="20px" fontSize="14px" flexDirection="column">
                {txns.map((t) => (
                  <Fragment key={t.transaction_id}>
                    <Text fontSize="12px" textTransform="uppercase" fontWeight="semibold" mb={1}>
                      {/* Pending transactions */}
                      {t.non_fungible_token_relation && t.non_fungible_token_relation?.summary}
                    </Text>
                    <a
                      href={`https://explorer.stacks.co/txid/${t.transaction_id}?chain=${process.env.NEXT_PUBLIC_ENV === 'production' ? 'mainnet' : 'testnet'
                        }`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Alert
                        status="error"
                        borderRadius={6}
                        mb="10px"
                        py="7px"
                        bg="#F7F7F7"
                        borderColor={colorMode === 'dark' ? '#333' : '#eee'}
                        borderWidth={1}
                      >
                        <Image src="/images/stacks-stx-logo.svg" w="18px" h="18px" alt="" mr="15px" />
                        {/* {t.contract_function} */}
                        <Text fontSize="14px" fontWeight="500" color="#6B6B70">
                          {/* Blockchain Record */}
                          {truncate(t.transaction_id, 18)}
                        </Text>
                        <Icon
                          as={FiExternalLink}
                          fontSize="17px"
                          color="#7a8087"
                          position="absolute"
                          right="8px"
                          top="8px"
                        />
                      </Alert>
                    </a>
                  </Fragment>
                ))}
              </Flex>
            )}

            <Flex id="buttons" flexWrap="wrap">
              {!isEmpty(user) && user_id === user.id && !for_sale && !auction && !forSale && (
                <SellButton
                  isDisabled={!isEmpty(txns) && user_id === user.id ? true : false}
                  onOpenModal={onOpenModal}
                />
              )}
              {!isEmpty(user) && user_id === user.id && !for_sale && !auction && (
                <SendButton onOpenModal={onOpenModal} />
              )}
              {!isEmpty(user) && user_id === user.id && !is_sold && for_sale && (
                <Cancel
                  id="cancel_sale"
                  isDisabled={!isEmpty(txns) && user_id === user.id ? true : false}
                  msg="Cancel Sale"
                  onOpen={() => onOpenModal('cancel')}
                />
              )}

              {/* Cancel sell from contract */}
              {!isEmpty(user) && user_id === user.id && forSale && (
                <Cancel id="cancel_from_contract" msg="Cancel Sale" onOpen={() => onOpenModal('cancel')} />
              )}

              {!isEmpty(user) && user_id === user.id && auction && (
                <Cancel msg="Cancel Auction" onOpen={() => onOpenModal('cancel-bid')} />
              )}
            </Flex>

            {true && (
              <Fragment>
                <SimpleGrid spacing="20px" columns={{ base: 1, md: 1 }} mb="15px">
                  {non_fungible_token_collection_id && (
                    <Flex
                      flexDirection="column"
                      borderWidth={1}
                      borderColor={colorMode === 'dark' ? '#333' : '#eee'}
                      borderRadius={6}
                      p="10px 15px"
                    >
                      <Text fontSize="11px">Collection Title</Text>
                      <Flex alignItems="center" mt="5px">
                        <Link href={`/collection/${non_fungible_token_collection_id}`}>
                          <a>
                            <Text fontWeight="600" fontSize="13px">
                              {non_fungible_token_collection?.name}
                            </Text>
                          </a>
                        </Link>
                      </Flex>
                    </Flex>
                  )}

                  {!isEmpty(edition) && (
                    <Flex
                      flexDirection="column"
                      borderWidth={1}
                      borderColor={colorMode === 'dark' ? '#333' : '#eee'}
                      borderRadius={6}
                      p="10px 15px"
                      cursor="pointer"
                      onClick={() => onOpenModalEditions('editions')}
                    >
                      <Text fontSize="11px">Number of Editions</Text>
                      <Text fontWeight="600" fontSize="13px" mt="5px">
                        {edition?.non_fungible_tokens_count}
                      </Text>
                    </Flex>
                  )}
                </SimpleGrid>
                {non_fungible_token_collection_id && (
                  <SimpleGrid>
                    <Flex
                      flex="1"
                      borderWidth={1}
                      borderColor={colorMode === 'dark' ? '#333' : '#eee'}
                      borderRadius={6}
                      p="13px 15px"
                      flexDirection="column"
                    >
                      <Text fontSize="11px">Description</Text>
                      <Text fontSize="12px" mt="5px">
                        {non_fungible_token_collection?.description}
                      </Text>
                    </Flex>
                  </SimpleGrid>
                )}
              </Fragment>
            )}

            <Flex id="owner_minter"></Flex>
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};
export default NftDetail;
